import React, { type CSSProperties } from "react";
import { useReportController } from "../Report.controller.ts";
import TableView from "../../../components/shared/table/Table.view.tsx";
import type ReportProperties from "../Report.properties.ts";
import MenuEnum from "../../../components/menu/Menu.enum.ts";
import MenuView from "../../../components/menu/Menu.view.tsx";
import styles from "./Report.desktop.module.css";
import { getDesktopMenuWidth } from "../../../tools/ConfigurationReader.ts";
import {
  FaAngleLeft,
  FaAngleRight,
  FaAnglesLeft,
  FaAnglesRight,
  FaFileCsv,
} from "react-icons/fa6";
import SmartSelectView from "../../../components/smart-select/SmartSelect.view.tsx";
import { useTranslation } from "react-i18next";
import canExportReport from "../../../security/CanExportReport.ts";

export default function ReportDesktopView(props: ReportProperties) {
  const { t } = useTranslation();
  const {
    gridRef,
    data,
    columnDefs,
    metaFromServer,
    pageLimits,
    firstClick,
    nextClick,
    prevClick,
    lastClick,
    limitChange,
    exportCSV,
    loading,
    sortChanged,
  } = useReportController(props);

  return (
    <div className={styles.main}>
      <MenuView menu={MenuEnum.Administration} />
      <div
        className={styles.tableContainer}
        style={
          {
            "--menuWidth": getDesktopMenuWidth(),
          } as CSSProperties
        }
      >
        <div className={styles.titleContainer}>
          <span className={styles.title}>{props.title}</span>
          <div className={styles.limitAndExport}>
            <SmartSelectView
              data={pageLimits}
              selectedValue={metaFromServer?.limit?.toString() ?? "10"}
              handleChange={limitChange}
              width="40"
            />
            {canExportReport() && (
              <FaFileCsv
                className={styles.csvExport}
                onClick={exportCSV}
                title={t("table.general.csvExport")}
              />
            )}
          </div>
        </div>
        <TableView
          gridRef={gridRef}
          data={data}
          columnDef={columnDefs}
          loading={loading}
          metaOutput={metaFromServer}
          onSortChanged={sortChanged}
        />
        <div className={styles.controlContainer}>
          <FaAnglesLeft
            className={styles.icon}
            onClick={firstClick}
            title={t("table.general.firstPage")}
          />
          <FaAngleLeft
            className={styles.icon}
            onClick={prevClick}
            title={t("table.general.prevPage")}
          />
          <span className={styles.text}>
            {t("table.general.page")} {metaFromServer?.page} /{" "}
            {metaFromServer?.totalPages}
          </span>
          <FaAngleRight
            className={styles.icon}
            onClick={nextClick}
            title={t("table.general.nextPage")}
          />
          <FaAnglesRight
            className={styles.icon}
            onClick={lastClick}
            title={t("table.general.lastPage")}
          />
        </div>
      </div>
    </div>
  );
}
